import { normalizeAutoNagSettings, selectNextAutoNagAt } from "./auto-nag";

function formatLocal(date, timeZone) {
  return new Intl.DateTimeFormat(undefined, {
    timeZone,
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

export function autoNagSummary(value, { now = new Date() } = {}) {
  const normalized = normalizeAutoNagSettings(value);
  if (!normalized.valid || !normalized.settings?.enabled) return "Auto-nag: Off";
  const { interval, timeZone } = normalized.settings;
  const cadence = interval.unit === "days"
    ? interval.value === 1 ? "Every day" : `Every ${interval.value} days`
    : `Every ${interval.value} hours`;
  const next = selectNextAutoNagAt({ config: normalized.settings, now });
  return next
    ? `Auto-nag: ${cadence} · next ${formatLocal(next, timeZone)}`
    : `Auto-nag: ${cadence}`;
}
